module.exports = __webpack_public_path__ + "media/images/sns01-479dc70f6422c82cae06c3ff210e332e.png";